import { Any } from "@cede/types";

const DEFAULT_WHITELISTED_FIELDS = [
  /balance\/.*$/,
  /balance$/,
  /metadata$/,
  /free$/,
  /total$/,
  /used$/,
  /vaultId$/,
  /amount$/,
  /token$/,
  /tokenSymbol$/,
  /tokenName$/,
  /tokenDecimals$/,
  /timestamp$/,
  /functionName$/,
  /params$/,
  /name$/,
  /version$/,
  /isAccepted$/,
  /txType$/,
  /startTime$/,
  /pageCount$/,
  /pageIndex$/,
  /status$/,
  /ticker$/,
  /totalBalance$/,
  /freeBalance$/,
  /cexName$/,
  /cexNames$/,
  /exchange$/,
  /exchangeId$/,
  /exchangeIds$/,
  /refTotalBalance$/,
  /refFreeBalance$/,
  /network$/,
  /toDeposit$/,
  /toWithdraw$/,
  /timer$/,
  /language$/,
  /currency$/,
  /symbol$/,
  /symbols$/,
  /rate$/,
  /symbolFrom$/,
  /symbolTo$/,
  /timestamp$/,
  /isNewUser$/,
  /permissions$/,
  /storage$/,
  /permissionsToSet$/,
  /setCexKeyMode$/,
  /walletType$/,
  /accountId$/,
  /transactions$/,
  /from$/,
  /to$/,
  /request$/,
  /pairSymbol$/,
  /orderSide$/,
  /orderType$/,
  /price$/,
  /tradeAndSend$/,
  /isExecuted$/,
  /label$/,
  /value$/,
  /isDisabled$/,
  /referrerSource$/,
  /origin$/,
  /functionName$/,
  /params$/,
  /opts$/,
  /tradeAndSend$/,
  /defiAddress$/,
  /externalName$/,
  /code$/,
  /clientId$/,
  /message$/,
  /requestId$/,
  /url$/,
  /originalErrorMessage$/,
  /sentry.origin$/,
  /origin$/,
  /sentry.sample_rate$/,
  /span_id$/,
  /trace_id$/,
];

function clearData(data: Any): Any {
  if (typeof data === "string") {
    return "********";
  }
  if (Array.isArray(data)) {
    return data.map(clearData);
  }
  if (typeof data === "object") {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, clearData(value)]));
  }
}

export function sanitize(
  data: Record<string, unknown>,
  whitelistedFields = DEFAULT_WHITELISTED_FIELDS,
  path = "",
): Record<string, unknown> {
  const sanitizedData = structuredClone(data);

  Object.keys(sanitizedData).forEach((key) => {
    // Sanitize fields
    const pathKey = path ? `${path}/${key}` : key;
    if (!whitelistedFields.find((regex) => regex.test(pathKey) || regex.test(key))) {
      sanitizedData[key] = clearData(sanitizedData[key]);
    }
    // Recursively sanitize objects
    else if (typeof sanitizedData[key] === "object") {
      if (Array.isArray(sanitizedData[key])) {
        sanitizedData[key] = (sanitizedData[key] as Record<string, unknown>[]).map((item) =>
          sanitize(item, whitelistedFields, pathKey),
        );
      } else sanitizedData[key] = sanitize(sanitizedData[key] as Record<string, unknown>, whitelistedFields, pathKey);
    }
  });
  return sanitizedData;
}
